require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-compact-recreational-vehicle.json") })
        }
      }, "path---es-fleet-compact-recreational-vehicle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-compact-recreational-vehicle!./.cache/json/es-fleet-compact-recreational-vehicle.json
// module id = 1079
// module chunks = 231608221292675